import React, { Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import { waitForLanguage } from './i18n'

// Component to hide initial loader when app is ready
const AppWithLoader: React.FC = () => {
  useEffect(() => {
    // Hide initial loader with fade out
    const loader = document.getElementById('initial-loader')
    if (loader) {
      loader.style.transition = 'opacity 0.3s ease-out'
      loader.style.opacity = '0'
      setTimeout(() => {
        loader.style.display = 'none'
      }, 300)
    }
  }, [])

  return <App />
}

// Wait for i18n resources to load before rendering
waitForLanguage().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Suspense fallback={<div className="min-h-screen bg-[#f8f7f8]"></div>}>
        <AppWithLoader />
      </Suspense>
    </React.StrictMode>,
  )
})
